import { useEffect } from 'react';
import { sendRejectedApplicationView } from 'api';
import { logger } from 'utils';

export const useRecordRejectedApplicationView = (shouldRecord: boolean): void => {
  useEffect(() => {
    if (!shouldRecord) {
      return;
    }

    const recordRejectedView = async () => {
      try {
        await sendRejectedApplicationView();
      } catch (error) {
        logger('sendRejectedApplicationView failed', error);
      }
    };

    recordRejectedView();
  }, [shouldRecord]);
};
